import React, { useRef, useEffect, useState } from "react";
import { getDir } from "orion-components/i18n/Config/selector";
import { useSelector } from "react-redux";

const Pointer = ({ hue, canvasHeight }) => {
	// Compute pointer position from hue
	const position = (hue / 360) * canvasHeight;
	const dir = useSelector((state) => getDir(state));

	return (
		<div
			style={{
				position: "absolute",
				cursor: "default",
				top: `${position}px`
			}}
		>
			<div
				style={{
					...(dir === "ltr" && { marginLeft: 2 }),
					...(dir === "rtl" && { marginRight: 2 }),
					width: "14px",
					height: "14px",
					boxShadow:
						"rgb(255, 255, 255) 0px 0px 0px 1.5px, rgba(0, 0, 0, 0.3) 0px 0px 1px 1px inset, rgba(0, 0, 0, 0.4) 0px 0px 1px 2px",
					borderRadius: "50%",
					transform: "translate(-2px, -2px)"
				}}
			></div>
		</div>
	);
};

function hslToHex(h, s, l) {
	l /= 100;
	const a = (s * Math.min(l, 1 - l)) / 100;
	const f = (n) => {
		const k = (n + h / 30) % 12;
		const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
		return Math.round(255 * color)
			.toString(16)
			.padStart(2, "0"); // convert to Hex and prefix with "0" if needed
	};
	return `#${f(0)}${f(8)}${f(4)}`;
}

const HuePicker = ({ hue, setHue, syncColor }) => {
	const canvasRef = useRef(null);
	const dragging = useRef(false);

	// Helper function to draw gradient on canvas
	const drawCanvas = (canvas, ctx) => {
		const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
		gradient.addColorStop(0, "rgba(255, 0, 0, 1)");
		gradient.addColorStop(0.17, "rgba(255, 255, 0, 1)");
		gradient.addColorStop(0.34, "rgba(0, 255, 0, 1)");
		gradient.addColorStop(0.51, "rgba(0, 255, 255, 1)");
		gradient.addColorStop(0.68, "rgba(0, 0, 255, 1)");
		gradient.addColorStop(0.85, "rgba(255, 0, 255, 1)");
		gradient.addColorStop(1, "rgba(255, 0, 0, 1)");

		ctx.fillStyle = gradient;
		ctx.fillRect(0, 0, canvas.width, canvas.height);
	};

	// Draw the gradient on the canvas
	useEffect(() => {
		const canvas = canvasRef.current;
		const ctx = canvas.getContext("2d");
		drawCanvas(canvas, ctx);
	}, []);

	// Function to update hue
	const updateHue = (event) => {
		const canvas = canvasRef.current;
		const rect = canvas.getBoundingClientRect();
		const y = event.clientY - rect.top;
		const hue = Math.round((y / rect.height) * 360);
		setHue(hue);
		syncColor(hslToHex(hue, 100, 50));
	};

	return (
		<div style={{ position: "relative" }}>
			<canvas
				style={{ borderRadius: 5 }}
				ref={canvasRef}
				width={14}
				height={109}
				onClick={updateHue}
				onMouseDown={() => {
					dragging.current = true;
				}}
				onMouseMove={(event) => {
					if (dragging.current) updateHue(event);
				}}
				onMouseUp={() => {
					dragging.current = false;
				}}
				onMouseLeave={() => {
					dragging.current = false;
				}} data-testid="orion-components-shared-components-shape-editor-components-shared-color-picker-hue-canvas"
			/>
			<Pointer hue={hue} canvasHeight={109} />
		</div>
	);
};

const Hue = ({ syncColor }) => {
	const [hue, setHue] = useState(112);

	return (
		<div>
			<HuePicker hue={hue} setHue={setHue} syncColor={syncColor} />
		</div>
	);
};

export default Hue;
